import { OvernightPackageRoomExtras } from '@features/DynamicPackagesConfigurationWizardNew/types';
import React, { FC } from 'react';

type ExtrasCategoryTitleProps = {
  extras: OvernightPackageRoomExtras;
  index: number;
};

export const ExtrasCategoryTitle: FC<ExtrasCategoryTitleProps> = ({ extras, index }) =>
  extras &&
  extras[index]?.category &&
  extras[index]?.category?.name !== extras[index - 1]?.category?.name ? (
    <h3>{extras[index]?.category?.name}</h3>
  ) : null;
